export const impactBlock = `
_type == 'impactBlock' => {
  list[]{
    ...,
    "equivalent": equivalent[_key == $lang][0].value,
  }
}
`
